import type { Place } from 'owa-graph-schema';
import { createObservableOperation } from 'owa-observable-operation';
import { getPlacesService } from 'places-service';
import type { TraceErrorObject } from 'owa-analytics-types';

const dest = createObservableOperation(
    'PLACES_LOAD_LOCATION',
    buildingId => ({ buildingId }),
    ({ buildingId }) => buildingId,
    ({ buildingId }) => getPlacesService().getPlaceFromBuildingId(buildingId)
);
const loadPlaceSucceeded: (
    actionMessage: {
        buildingId: any;
    } & {
        result: Place;
    }
) => {
    buildingId: any;
} & {
    result: Place;
} = dest.onSucceeded;
const invokeLoadPlace: (buildingId: any) => Promise<Place> = dest.startAsync;
const loadPlaceFailed: (
    actionMessage: {
        buildingId: any;
    },
    error?: TraceErrorObject
) => {
    buildingId: any;
} & {
    error?: TraceErrorObject;
} = dest.onFailed;

export { invokeLoadPlace, loadPlaceSucceeded, loadPlaceFailed };
